export default "__VITE_ASSET__DLrUWgZ4__"